import { useScrollReveal } from "../../../hooks";

export default function Section({ children, style: customStyle = {} }) {
  const [ref, visible] = useScrollReveal();
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(40px)",
      transition: "all 0.8s cubic-bezier(0.16, 1, 0.3, 1)",
      ...customStyle,
    }}>
      {children}
    </div>
  );
}
